<div class="grid">
  
    <app-page-header class="col-12" icon="pi pi-book" title="Users" description="A list of all the users you have access to.">
      <div headerFooter>
        <div class="p-3 pt-0">
          <div class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input type="text" [(ngModel)]="searchInput" pInputText class="border-1 surface-border w-full" placeholder="Search" />
          </div>
        </div>
      </div>
    </app-page-header>
  
    <ng-container *ngIf="$any( $any(users | async) | arrangement:searchInput) as users">
      <ng-container *ngIf="users.length; else zeroUsers">
        <div class="col-12 py-3" *ngFor="let user of users">
            <div class="app-card shadow-2 surface-card p-4 border-2 border-transparent">
              <div class="flex flex-row align-items-center justify-content-between">
                <div class="flex align-items-center">
                  <p-avatar styleClass="app-avatar mr-3" label="{{ user.data.firstName.charAt(0) | uppercase }}{{ user.data.lastName.charAt(0) | uppercase }}" size="large" shape="circle"></p-avatar>
                  <div>
                    <span class="text-900 text-xl mb-2 font-medium">{{ user.data.firstName }} {{ user.data.lastNam }}</span>
                    <p class="m-0 text-600 font-medium text-sm">{{ user.data.email }}</p>
                  </div>
                </div>
                <div class="flex">
                  <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded " [routerLink]="['/dashboard/users/update',user.data.id]"></button>
                </div>
              </div>
            </div>
          </div>          
      </ng-container>
      <ng-template #zeroUsers>
        <p-message *ngIf="searchInput" class="col-12" severity="info" text="We didn't find any users that matched your search criteria." styleClass="p-mr-2"></p-message>
        <p-message *ngIf="!searchInput" class="col-12" severity="info" text="We didn't find any users for your account." styleClass="p-mr-2"></p-message>
      </ng-template>
    </ng-container>
  
  </div>